import { CommonErrorCode, GroupErrorCode } from '~commonInfra/utils/ErrorCodes';
import { Set } from '~commonInfra/utils/Set';

import { siteUrlsSelector } from '../../../../bootstrap/redux/selectors/SiteUrlsSelectors';
import { getAppStore } from '../../../../bootstrap/redux/store/AppStore';
import { Messages } from '../../../../codegen/Localize';
import {
  createMultipleItemResultNotificationValues,
  MultipleItemResultNotificationValues
} from '../../../../commonInfra/contentActions/ActionMessages';
import { ContentActionNotification } from '../../../../commonInfra/contentActions/ContentActionNotification';
import {
  IErrorItem, MultipleItemResult
} from '../../../../commonInfra/contentActions/MultipleItemResult';
import { L10n } from '../../../../commonInfra/L10n/L10n';
import { IError } from '../../../../httpClient/serverApi/types/IError';
import { IResult } from '../../../../httpClient/serverApi/types/IResponse';
import { IGroupInfo } from '../../models/IGroupInfo';

function notify(result: IResult, groups: Set<IGroupInfo>) {
    // create a notification object for result reporting
    const notification: MultipleItemResultNotificationValues = createMultipleItemResultNotificationValues(
        new MultipleItemResult(groups, result),
        {
        describeSuccessSummary: (successCount: number) => {
            return Messages.deleteGroupsSuccess({ ITEM_COUNT: successCount, ITEM_COUNT_LOC: L10n.localizedCount(successCount)});
        },
        describeErrorSummary: (errorCount: number) => {
            return Messages.deleteGroupsError({ ERROR_COUNT: errorCount, ERROR_COUNT_LOC: L10n.localizedCount(errorCount)});
        },
        describeErrorDetail: (errorItem: IErrorItem<IGroupInfo>) => {
            const siteUrls = siteUrlsSelector(getAppStore().getState());
            return {
                itemName: errorItem.item.name,
                itemUrl: siteUrls.groupUrl(errorItem.item.id),
                errorMessage: errorMessageFor(errorItem.error, errorItem.item.name)
                };
            }
        }
    );

    // pass the notification object to the service for displaying
    ContentActionNotification.displayItemizedToastsForResult(notification);
}

function errorMessageFor(error: IError, groupName: string) {
    switch (error.code) {
        case CommonErrorCode.GroupNotFound:
            return Messages.errorGroupNotFound({ ITEM_NAME: L10n.elideIfLong(groupName) });
        case GroupErrorCode.GroupCannotBeDeleted:
            return Messages.errorUnableToDeleteAllUsersGroup({ GROUP_NAME: L10n.elideIfLong(groupName) });
        default:
            return Messages.errorUnknown();
    }
}

export const DeleteGroupsNotificationAction = {
    notify
};

export type DeleteGroupsNotificationAction = typeof DeleteGroupsNotificationAction;
